export enum DataType {
    STR,
    INT,
    DEC,
    BOOL,
    DATE,
    TIME,
    OPTION
}
